import React from 'react';
import 'font-awesome/css/font-awesome.min.css';
import playstoreImage from '../footer/images/playstore.png';
import appstoreImage from '../images/appStore.png'; 
import returned from '../images/return.jpg';
import './footer.css';
import { useSelector } from 'react-redux';

export const Footer = () => {
  const theme = useSelector((state)=>state.theme);
   const style =  theme === "light"? {color:"rgb(72, 71, 71)"}:{ color:"#D6D6D6"};
  return (
    <div>
      <footer style={ theme==="light"?{ marginTop: '50px' }:{ marginTop: '0px' }}>
        <div className="footer" style={{ backgroundColor:theme === "light"?"white":"#44444C"}}>
          <div className="footer-1">
            <h4 style={theme==="light"?{color:"black"}:{color:"white"}}>ONLINE SHOPPING</h4>
            <ul >
              <li style={style}>Men</li>
              <li style={style}>Women</li>
              <li style={style}>Kids</li>
              <li style={style}>Home & Living</li>
              <li style={style}>Beauty</li>
              <li style={style}>Gift Cards</li>
              <li style={style}>Myntra Insider</li>
            </ul>
          </div>
          <div className="footer-2">
            <h4 style={theme==="light"?{color:"black"}:{color:"white"}}>CUSTOMER POLICIES</h4>
            <ul >
              <li style={style}>Contact Us</li>
              <li style={style}>FAQ</li>
              <li style={style}>T&C</li>
              <li style={style}>Terms Of Use</li>
              <li style={style}>Track Orders</li>
              <li style={style}>Shipping</li>
              <li style={style}>Cancellation</li>
              <li style={style}>Returns</li>
              <li style={style}>Privacy policy</li>
              <li style={style}>Grievance Officer</li>
            </ul>
          </div>
          <div className="footer-3">
            <h4 style={theme==="light"?{color:"black"}:{color:"white"}}>EXPERIENCE MYNTRA APP ON MOBILE</h4>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={playstoreImage} alt="Play Store" width="150px" style={{marginRight:"5px"}}/>
              <img src={appstoreImage} alt="App Store" width="150px" />
            </div>
            <p><b style={theme==="light"?{color:"black"}:{color:"white"}}>KEEP IN TOUCH</b></p>
            <div style={{ marginTop: '15px' }} className='Dark-theme-txt-ftr'>
              <i className="fa fa-facebook fa-xl" style={style}></i>
              <i className="fa fa-twitter fa-xl" style={style}></i>
              <i className="fa fa-youtube fa-xl" style={style}></i>
              <i className="fa fa-instagram fa-xl"style={style}></i>
            </div>
          </div>
          <div className="footer-4" style={{ marginTop: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={returned} alt="Return Policy" height="50px" />
              <p style={style}><b>100% ORIGINAL guarantee</b> for all products at myntra.com</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
              <img src={returned} alt="Return Policy" height="50px" />
              <p style={style}><b>Return within 14 days</b> of receiving your order</p>
            </div>
          </div>
          <div className="footer-5">
            <h4 style={theme==="light"?{color:"black"}:{color:"white"}}>USEFUL LINKS</h4>
            <ul className='Dark-theme-txt-ftr'>
              <li style={style}>Blog</li>
              <li style={style}>Careers</li>
              <li style={style}>Site Map</li>
              <li style={style}>Corporate Information</li>
              <li style={style}>Whitehat</li>
              <li style={style}>Cleartrip</li>
            </ul>
          </div>
          <div className="footer-6">
            <h4 style={theme==="light"?{color:"black"}:{color:"white"}}>POPULAR SEARCHES</h4>
            <p className='ftr-popular-search'  style={style}>
              Adidas | Arrow | Fila | Online Shopping | Nike | Pepe Jeans | Puma | United Colors Of Benetton | Fastrack | Shorts | Being Human | Skirts | Woodland | Supra | Dresses | Blazers | T-Shirts | Clothing | Jewellery | Shoes | Bags | Watches | Caps | Shirts | Backpacks | Flip Flops | Sunglasses | Kurtas | Lingerie | Jackets | Skechers | Saree | Puma T-Shirts | Woodland Shoes | Titan Watches | Fastrack Watches | Wrangler Shirts | Adidas T-Shirts | Nike Shoes | Roadster Shirts | Casual Shoes | Running Shoes | Nike Sports Shoes | Jeans | Being Human | T-Shirts | Converse Shoes | Cricket Shoes
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

